import { gql } from '@apollo/client';

import WORKTIMES from '../fragments/availabilities/worktimes';

// eslint-disable-next-line import/prefer-default-export
export const UPDATE_WORKTIME = gql`
  ${WORKTIMES}
  mutation UPDATE_WORKTIME($updatedDoc: [WorktimeInput!]!, $filter: [WorktimeInput!]!) {
    updateManyWorktimeEntity(updatedDoc: $updatedDoc, filter: $filter) {
      ...Worktimes
    }
  }
`;

export const CREATE_WORKTIME = gql`
  ${WORKTIMES}
  mutation CREATE_WORKTIME($doc: [WorktimeInput!]!) {
    createManyWorktimeEntity(doc: $doc) {
      ...Worktimes
    }
  }
`;

export const DELETE_WORKTIME = gql`
  mutation DELETE_WORKTIME($ids: [String!]!) {
    deleteManyWorktimeEntity(ids: $ids) {
      message
    }
  }
`;
